export const IS_MAC = navigator.userAgent.indexOf('Mac') !== -1;
